module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAHBJREFUKFOV0LkNgDAQRNG/bYBIKQPJxdiiJlIKQfQBEX1g5MAWvjg2fhrNrFiD5ePJL1wLtZoeWBAab6SEE3gAnXMZLkAFbBkuQZnY/a6QXIMuMcJPMMJvMMaGFRgAt1q5jumHQg070nIyA7oE78kXBps7WHYmW6gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button-icon-02.png
// module id = zgt7
// module chunks = 1